var cov_2adtym56ri = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Spin/Multiple.tsx",
      hash = "f12fae70397f20bb6b4bc19e169c0f67a036753a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Spin/Multiple.tsx",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 16
        },
        end: {
          line: 18,
          column: 68
        }
      },
      "1": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 68
        }
      },
      "2": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 23,
          column: 90
        }
      },
      "3": {
        start: {
          line: 27,
          column: 26
        },
        end: {
          line: 27,
          column: 47
        }
      },
      "4": {
        start: {
          line: 28,
          column: 14
        },
        end: {
          line: 28,
          column: 23
        }
      },
      "5": {
        start: {
          line: 29,
          column: 32
        },
        end: {
          line: 29,
          column: 42
        }
      },
      "6": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 36,
          column: 3
        }
      },
      "7": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 29
        }
      },
      "8": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 37
        }
      },
      "9": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 18
        }
      },
      "10": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 46,
          column: 3
        }
      },
      "11": {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 50,
          column: 86
        }
      },
      "12": {
        start: {
          line: 54,
          column: 26
        },
        end: {
          line: 54,
          column: 47
        }
      },
      "13": {
        start: {
          line: 55,
          column: 22
        },
        end: {
          line: 55,
          column: 44
        }
      },
      "14": {
        start: {
          line: 56,
          column: 16
        },
        end: {
          line: 56,
          column: 91
        }
      },
      "15": {
        start: {
          line: 57,
          column: 2
        },
        end: {
          line: 57,
          column: 106
        }
      },
      "16": {
        start: {
          line: 67,
          column: 16
        },
        end: {
          line: 67,
          column: 68
        }
      },
      "17": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 72,
          column: 3
        }
      },
      "18": {
        start: {
          line: 76,
          column: 26
        },
        end: {
          line: 76,
          column: 47
        }
      },
      "19": {
        start: {
          line: 77,
          column: 15
        },
        end: {
          line: 77,
          column: 45
        }
      },
      "20": {
        start: {
          line: 78,
          column: 2
        },
        end: {
          line: 86,
          column: 3
        }
      },
      "21": {
        start: {
          line: 96,
          column: 2
        },
        end: {
          line: 102,
          column: 3
        }
      },
      "22": {
        start: {
          line: 106,
          column: 26
        },
        end: {
          line: 106,
          column: 47
        }
      },
      "23": {
        start: {
          line: 107,
          column: 19
        },
        end: {
          line: 107,
          column: 48
        }
      },
      "24": {
        start: {
          line: 109,
          column: 2
        },
        end: {
          line: 118,
          column: 3
        }
      },
      "25": {
        start: {
          line: 121,
          column: 27
        },
        end: {
          line: 121,
          column: 77
        }
      },
      "26": {
        start: {
          line: 121,
          column: 51
        },
        end: {
          line: 121,
          column: 77
        }
      },
      "27": {
        start: {
          line: 122,
          column: 28
        },
        end: {
          line: 122,
          column: 77
        }
      },
      "28": {
        start: {
          line: 122,
          column: 52
        },
        end: {
          line: 122,
          column: 77
        }
      },
      "29": {
        start: {
          line: 125,
          column: 26
        },
        end: {
          line: 125,
          column: 47
        }
      },
      "30": {
        start: {
          line: 126,
          column: 2
        },
        end: {
          line: 135,
          column: 3
        }
      },
      "31": {
        start: {
          line: 139,
          column: 2
        },
        end: {
          line: 139,
          column: 90
        }
      },
      "32": {
        start: {
          line: 143,
          column: 2
        },
        end: {
          line: 143,
          column: 87
        }
      }
    },
    fnMap: {
      "0": {
        name: "simpleRender",
        decl: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 21
          }
        },
        loc: {
          start: {
            line: 17,
            column: 113
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "DoubleBounce",
        decl: {
          start: {
            line: 22,
            column: 16
          },
          end: {
            line: 22,
            column: 28
          }
        },
        loc: {
          start: {
            line: 22,
            column: 51
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 22
      },
      "2": {
        name: "Wave",
        decl: {
          start: {
            line: 26,
            column: 16
          },
          end: {
            line: 26,
            column: 20
          }
        },
        loc: {
          start: {
            line: 26,
            column: 42
          },
          end: {
            line: 47,
            column: 1
          }
        },
        line: 26
      },
      "3": {
        name: "CubeGrid",
        decl: {
          start: {
            line: 49,
            column: 16
          },
          end: {
            line: 49,
            column: 24
          }
        },
        loc: {
          start: {
            line: 49,
            column: 47
          },
          end: {
            line: 51,
            column: 1
          }
        },
        line: 49
      },
      "4": {
        name: "ChasingRing",
        decl: {
          start: {
            line: 53,
            column: 16
          },
          end: {
            line: 53,
            column: 27
          }
        },
        loc: {
          start: {
            line: 53,
            column: 49
          },
          end: {
            line: 58,
            column: 1
          }
        },
        line: 53
      },
      "5": {
        name: "multRenderDiv",
        decl: {
          start: {
            line: 62,
            column: 9
          },
          end: {
            line: 62,
            column: 22
          }
        },
        loc: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 73,
            column: 1
          }
        },
        line: 66
      },
      "6": {
        name: "Default",
        decl: {
          start: {
            line: 75,
            column: 16
          },
          end: {
            line: 75,
            column: 23
          }
        },
        loc: {
          start: {
            line: 75,
            column: 45
          },
          end: {
            line: 87,
            column: 1
          }
        },
        line: 75
      },
      "7": {
        name: "multRenderSvg",
        decl: {
          start: {
            line: 91,
            column: 9
          },
          end: {
            line: 91,
            column: 22
          }
        },
        loc: {
          start: {
            line: 95,
            column: 2
          },
          end: {
            line: 103,
            column: 1
          }
        },
        line: 95
      },
      "8": {
        name: "twelveCircle",
        decl: {
          start: {
            line: 105,
            column: 9
          },
          end: {
            line: 105,
            column: 21
          }
        },
        loc: {
          start: {
            line: 105,
            column: 79
          },
          end: {
            line: 119,
            column: 1
          }
        },
        line: 105
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 121,
            column: 27
          },
          end: {
            line: 121,
            column: 28
          }
        },
        loc: {
          start: {
            line: 121,
            column: 51
          },
          end: {
            line: 121,
            column: 77
          }
        },
        line: 121
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 122,
            column: 28
          },
          end: {
            line: 122,
            column: 29
          }
        },
        loc: {
          start: {
            line: 122,
            column: 52
          },
          end: {
            line: 122,
            column: 77
          }
        },
        line: 122
      },
      "11": {
        name: "ThreeBounce",
        decl: {
          start: {
            line: 124,
            column: 16
          },
          end: {
            line: 124,
            column: 27
          }
        },
        loc: {
          start: {
            line: 124,
            column: 49
          },
          end: {
            line: 136,
            column: 1
          }
        },
        line: 124
      },
      "12": {
        name: "ChasingDots",
        decl: {
          start: {
            line: 138,
            column: 16
          },
          end: {
            line: 138,
            column: 27
          }
        },
        loc: {
          start: {
            line: 138,
            column: 50
          },
          end: {
            line: 140,
            column: 1
          }
        },
        line: 138
      },
      "13": {
        name: "FourDots",
        decl: {
          start: {
            line: 142,
            column: 16
          },
          end: {
            line: 142,
            column: 24
          }
        },
        loc: {
          start: {
            line: 142,
            column: 47
          },
          end: {
            line: 144,
            column: 1
          }
        },
        line: 142
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 36,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 36,
            column: 3
          }
        }, {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 36,
            column: 3
          }
        }],
        line: 31
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Spin/Multiple.tsx";
import React from 'react';
import Spin from './Spin';
import { defaultClass, chasingDotsClass, doubleBounceClass, waveClass, cubeGridClass, chasingRingClass, scaleCircleClass, threeBounceClass, fourDotsClass } from './styles';
import { formatSize } from './util';

function simpleRender(classname, i, _ref) {
  var color = _ref.color,
      itemStyle = _ref.itemStyle;
  cov_2adtym56ri.f[0]++;
  var style = (cov_2adtym56ri.s[0]++, Object.assign({
    backgroundColor: color
  }, itemStyle));
  cov_2adtym56ri.s[1]++;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      key: i,
      style: style,
      className: classname('item'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 19,
        columnNumber: 10
      }
    })
  );
}

export function DoubleBounce(props) {
  cov_2adtym56ri.f[1]++;
  cov_2adtym56ri.s[2]++;
  return (
    /*#__PURE__*/
    React.createElement(Spin, Object.assign({}, props, {
      count: 2,
      spinClass: doubleBounceClass,
      render: simpleRender,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 23,
        columnNumber: 10
      }
    }))
  );
}
export function Wave(prop) {
  cov_2adtym56ri.f[2]++;

  var _ref2 = (cov_2adtym56ri.s[3]++, formatSize(prop.size)),
      value = _ref2.value,
      unit = _ref2.unit;

  var width = (cov_2adtym56ri.s[4]++, value / 7);
  var margin = (cov_2adtym56ri.s[5]++, value / 20);
  cov_2adtym56ri.s[6]++;

  if (unit === 'px') {
    cov_2adtym56ri.b[0][0]++;
    cov_2adtym56ri.s[7]++;
    width = Math.floor(width);
    cov_2adtym56ri.s[8]++;
    margin = Math.ceil(margin) + unit;
  } else {
    cov_2adtym56ri.b[0][1]++;
    cov_2adtym56ri.s[9]++;
    margin = '2px';
  }

  cov_2adtym56ri.s[10]++;
  return (
    /*#__PURE__*/
    React.createElement(Spin, Object.assign({}, prop, {
      itemStyle: {
        width: width + unit,
        marginRight: margin
      },
      count: 5,
      spinClass: waveClass,
      render: simpleRender,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 39,
        columnNumber: 5
      }
    }))
  );
}
export function CubeGrid(props) {
  cov_2adtym56ri.f[3]++;
  cov_2adtym56ri.s[11]++;
  return (
    /*#__PURE__*/
    React.createElement(Spin, Object.assign({}, props, {
      count: 9,
      spinClass: cubeGridClass,
      render: simpleRender,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 50,
        columnNumber: 10
      }
    }))
  );
}
export function ChasingRing(prop) {
  cov_2adtym56ri.f[4]++;

  var _ref3 = (cov_2adtym56ri.s[12]++, formatSize(prop.size)),
      value = _ref3.value,
      unit = _ref3.unit;

  var borderWidth = (cov_2adtym56ri.s[13]++, "".concat(value / 10).concat(unit));
  var style = (cov_2adtym56ri.s[14]++, {
    borderWidth: borderWidth,
    borderTopColor: prop.color,
    backgroundColor: 'transparent'
  });
  cov_2adtym56ri.s[15]++;
  return (
    /*#__PURE__*/
    React.createElement(Spin, Object.assign({}, prop, {
      count: 4,
      itemStyle: style,
      spinClass: chasingRingClass,
      render: simpleRender,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 57,
        columnNumber: 10
      }
    }))
  );
} // =============================================================================

function multRenderDiv(className, i, _ref4) {
  var color = _ref4.color,
      itemStyle = _ref4.itemStyle,
      itemClass = _ref4.itemClass;
  cov_2adtym56ri.f[5]++;
  var style = (cov_2adtym56ri.s[16]++, Object.assign({
    backgroundColor: color
  }, itemStyle));
  cov_2adtym56ri.s[17]++;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      key: i,
      className: className('item', itemClass),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 5
      }
    },
    /*#__PURE__*/
    React.createElement("div", {
      style: style,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 7
      }
    }))
  );
}

export function Default(prop) {
  cov_2adtym56ri.f[6]++;

  var _ref5 = (cov_2adtym56ri.s[18]++, formatSize(prop.size)),
      value = _ref5.value,
      unit = _ref5.unit;

  var size = (cov_2adtym56ri.s[19]++, Math.ceil(value / 12.5) + unit);
  cov_2adtym56ri.s[20]++;
  return (
    /*#__PURE__*/
    React.createElement(Spin, Object.assign({}, prop, {
      count: 12,
      itemStyle: {
        width: size,
        borderRadius: size
      },
      spinClass: defaultClass,
      render: multRenderDiv,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 79,
        columnNumber: 5
      }
    }))
  );
} // =============================================================================

function multRenderSvg(className, i, _ref6) {
  var color = _ref6.color,
      itemSize = _ref6.itemSize,
      itemClass = _ref6.itemClass;
  cov_2adtym56ri.f[7]++;
  cov_2adtym56ri.s[21]++;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      key: i,
      className: className('item', itemClass),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 97,
        columnNumber: 5
      }
    },
    /*#__PURE__*/
    React.createElement("svg", {
      width: itemSize,
      height: itemSize,
      viewBox: "0 0 100 100",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 98,
        columnNumber: 7
      }
    },
    /*#__PURE__*/
    React.createElement("circle", {
      fill: color,
      cx: 50,
      cy: 50,
      r: 50,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 99,
        columnNumber: 9
      }
    })))
  );
}

function twelveCircle(prop, type) {
  cov_2adtym56ri.f[8]++;

  var _ref7 = (cov_2adtym56ri.s[22]++, formatSize(prop.size)),
      value = _ref7.value,
      unit = _ref7.unit;

  var itemSize = (cov_2adtym56ri.s[23]++, (value / 7).toFixed(3) + unit);
  cov_2adtym56ri.s[24]++;
  return (
    /*#__PURE__*/
    React.createElement(Spin, Object.assign({}, prop, {
      count: 12,
      itemSize: itemSize,
      itemClass: type,
      spinClass: scaleCircleClass,
      render: multRenderSvg,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 110,
        columnNumber: 5
      }
    }))
  );
}

cov_2adtym56ri.s[25]++;
export var ScaleCircle = function ScaleCircle(opt) {
  cov_2adtym56ri.f[9]++;
  cov_2adtym56ri.s[26]++;
  return twelveCircle(opt, 'scale');
};
cov_2adtym56ri.s[27]++;
export var FadingCircle = function FadingCircle(opt) {
  cov_2adtym56ri.f[10]++;
  cov_2adtym56ri.s[28]++;
  return twelveCircle(opt, 'fade');
};
export function ThreeBounce(prop) {
  cov_2adtym56ri.f[11]++;

  var _ref8 = (cov_2adtym56ri.s[29]++, formatSize(prop.size)),
      value = _ref8.value,
      unit = _ref8.unit;

  cov_2adtym56ri.s[30]++;
  return (
    /*#__PURE__*/
    React.createElement(Spin, Object.assign({}, prop, {
      count: 3,
      style: {
        width: value * 2 + unit,
        height: 'auto'
      },
      itemSize: value / 2 + unit,
      spinClass: threeBounceClass,
      render: multRenderSvg,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 127,
        columnNumber: 5
      }
    }))
  );
}
export function ChasingDots(props) {
  cov_2adtym56ri.f[12]++;
  cov_2adtym56ri.s[31]++;
  return (
    /*#__PURE__*/
    React.createElement(Spin, Object.assign({}, props, {
      count: 2,
      spinClass: chasingDotsClass,
      render: multRenderSvg,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 139,
        columnNumber: 10
      }
    }))
  );
}
export function FourDots(props) {
  cov_2adtym56ri.f[13]++;
  cov_2adtym56ri.s[32]++;
  return (
    /*#__PURE__*/
    React.createElement(Spin, Object.assign({}, props, {
      count: 4,
      spinClass: fourDotsClass,
      render: multRenderSvg,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 143,
        columnNumber: 10
      }
    }))
  );
}